// extracted by css-extract-rspack-plugin
export default {"triggerWrapper":"triggerWrapper-ed6yA6"};